module.exports = __webpack_public_path__ + "static/img/logo.a170f8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 4